import { type DatePatternPreset } from './date-pattern-preset';

/**
 * The registry's coded default for `brand.dateFormat`, and what a client renders
 * with until the public payload lands.
 *
 * Typed as a preset so it can never drift outside the grammar the schema
 * accepts; the api definition imports it rather than restating the string.
 */
export const DEFAULT_DATE_PATTERN: DatePatternPreset = 'DD/MM/YYYY';
